//system
import { Injectable } from '@angular/core';
import { HttpService } from './common/http.service';

//services
import { LogService } from './common/log.service';

//environment
import { Location as LocationV2 } from 'src/app/models/location';
import { EnvironmentService } from './environment.service';

//models


@Injectable({
  providedIn: 'root'
})
export class FacilityV2Service {
  private httpServiceInstance: HttpService;

  constructor(private logService: LogService
    , private httpService: HttpService
    , private _environmentService: EnvironmentService
  ) { 
    this.httpServiceInstance = this.httpService.createInstance({
      baseUrl: `${this._environmentService.getFacilityConfig().facilityApiV2Url}api/v${this._environmentService.getFacilityConfig().facilityApiV2}`
    });
  }

  getLocationById(locationId: number): Promise<LocationV2> {
    return this.httpServiceInstance.getPromise<LocationV2>(`location/${locationId}`);
  }
}